import React, { Fragment, useState } from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import * as PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ManageForm from 'legacy/src/components/assignment/Assignment/components/ManageForm';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import UpdateResourceSettings from 'chameleon-src/components/UpdateResourceSettings';

const UpdateSettingsAction = (props) => {
  const {
    assignment,
    assessment = {},
    onClose,
    onUpdate,
    subjectInfo,
    onActionClick,
    isPilot,
    isVideo,
    isSPP,
    startsAt,
    dueAt,
    isPPC: propIsPPC,
    disabled,
  } = props;
  const { id: assessmentId } = assessment;
  const [settingsModalOpen, toggleSettingsModal] = useState(false);
  const hasOwnModal = !onActionClick;
  const isPPC = propIsPPC || assessment.is_ppc;

  const handleClick = (event) => {
    event.stopPropagation();

    if (hasOwnModal) {
      toggleSettingsModal(!settingsModalOpen);
    } else {
      onActionClick && onActionClick();
      onClose && onClose();
    }
  };

  return (
    <Fragment>
      <AccessibilityWrapper>
        <SingleAction
          onClick={handleClick}
          tabIndex={0}
          aria-label="Update Settings"
          iconName="update_settings"
          disabled={disabled}
        >
          <span className="item-text">Update Settings</span>
        </SingleAction>
      </AccessibilityWrapper>
      {settingsModalOpen &&
        (isVideo ? (
          <UpdateResourceSettings
            {...props}
            assignment={{
              ...assignment,
              starts_at: startsAt,
              due_at: dueAt,
            }}
            closeManageModal={() => {
              toggleSettingsModal(false);
              onClose();
            }}
            onUpdateAssignment={onUpdate}
          />
        ) : (
          <ManageForm
            itemId={assessmentId}
            assignment={{
              ...assignment,
              item: {
                title: assignment.title,
              },
              testTakingLocation: assignment.testTakingLocation,
              assignees: [
                {
                  id: assignment.section_id,
                  name: assignment.section_name,
                },
              ],
              starts_at: startsAt,
              due_at: dueAt,
            }}
            closeManageModal={() => {
              toggleSettingsModal(false);
              onClose();
            }}
            hasScrambleQuestionsPerStudent={
              assignment?.scramble_questions_per_student
                ? 'scramble_questions_per_student'
                : null
            }
            hasImmediateFeedback={assignment.has_immediate_feedback}
            immediateFeedbackAttempts={String(
              assignment.immediate_feedback_attempts,
            )}
            onUpdateAssignment={onUpdate}
            subjectInfo={subjectInfo}
            isPilot={isPilot}
            isSPP={isSPP}
            assessmentGroupInfo={assignment.assessment_group}
            assessments={[assessment]}
            canUpdateAll
            isPPC={isPPC}
          />
        ))}
    </Fragment>
  );
};

UpdateSettingsAction.propTypes = {
  assignment: PropTypes.object.isRequired,
};

export default withRouter(UpdateSettingsAction);
